<template>
    <v-carousel>
        <v-carousel-item
                v-for="(item,i) in offerPhotos"
                v-bind:src="item.src"
                v-bind:key="i"
                v-bind:class="{ video: item.type == 'video' }"
                v-bind:style="makeStyle(item)"
        ></v-carousel-item>
    </v-carousel>
</template>


<script>
    export default {
        props: {
            offerPhotos: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },
        methods: {
            makeStyle: function (item) {
                if (item.type === 'picture') {
                    return {
                        backgroundImage: `url(${item.src})`,
                        backgroundSize: 'contain'
                    };
                } else if (item.type === 'video') {
                    return {
                        backgroundImage: `url('/img/video-play.png'), url(${item.src})`,
                        backgroundSize: '90px 90px, contain'
                    };
                }
            }
        },
        mounted: function () {

            console.log('mounted');
            let j = 0;
            let len = 0;
            if(this.offerPhotos){
                for (j = 0; len = this.offerPhotos.length, j < len; j++) {
                    console.log(this.offerPhotos[j].src);
                    console.log(this.offerPhotos[j].type);
                    //if (this.offerPhotos[j])
                }
            }

        }
        /*,
        watch: {
            offerPhotos: function (value) {
                this.items = value;
            }
        },
        data: function () {
            return {
                items: []
            }
        }*/
    }
</script>


<style lang="scss">
    .carousel {
        height: 700px;
        @media screen and (max-width: 800px) {
            height: 500px;
        }
        @media screen and (max-width: 480px) {
            height: 300px;
        }
    }
    .carousel__left, .carousel__right {
        .btn {
            background-color: rgba(30,30,30,.5);
            &:hover {
                background-color: rgba(30,30,30,.7);
            }
        }
    }

</style>